// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/pic-responsibility.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/pic-responsibility/pic-responsibility.js';

mount([g0]);
